export default "__VITE_ASSET__CxFmVXhT__"